var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewMatchesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "profile",
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.912,
    height: 86.666,
    viewBox: "0 0 89.912 86.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_768",
    "data-name": "Group 768"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3932",
    "data-name": "Path 3932",
    d: "M-183.081,402.2q-11.568,0-23.136,0c-1.793,0-3.041-.887-3.22-2.486a4.1,4.1,0,0,1,.473-2.131c3.591-7.27,7.312-14.477,10.8-21.8a45.905,45.905,0,0,0,2.328-7.327c1.4-4.982,2.737-9.985,4.113-14.975a2.925,2.925,0,0,1,3.187-2.44q5.49-.01,10.98,0a3.063,3.063,0,0,1,3.453,2.634q2.77,10.128,5.532,20.258a8.063,8.063,0,0,0,.567,1.449c3.68,7.384,7.387,14.755,11.031,22.157a4.359,4.359,0,0,1,.438,2.412c-.22,1.472-1.475,2.246-3.212,2.247Q-171.415,402.208-183.081,402.2Zm3.833-45.327c-2.255,0-4.41.035-6.562-.02-.715-.018-.94.259-1.108.89-1.121,4.216-2.245,8.431-3.437,12.627-.842,2.965-1.454,5.99-2.909,8.779-2.785,5.339-5.414,10.759-8.106,16.146-.156.312-.3.63-.484,1.021h37.792c-.178-.391-.313-.714-.469-1.026-2.567-5.133-5.1-10.282-7.721-15.389a33.814,33.814,0,0,1-2.612-6.923C-176.265,367.632-177.763,362.308-179.247,356.877Z",
    transform: "translate(246.417 -315.555)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3933",
    "data-name": "Path 3933",
    d: "M-432.3,351.052q7.645,0,15.289,0c2.2,0,3.329,1.107,3.33,3.291,0,7.612.016,15.224-.017,22.836a5.48,5.48,0,0,1-.471,2.16c-3.084,6.863-6.237,13.695-9.3,20.565a3.53,3.53,0,0,1-3.658,2.324c-3.527-.055-7.057-.04-10.584-.007a3.322,3.322,0,0,1-3.359-2.169c-3.131-6.949-6.307-13.877-9.432-20.828a5.238,5.238,0,0,1-.439-2.069c-.031-7.579-.02-15.158-.019-22.738,0-2.229,1.139-3.364,3.376-3.365Q-439.944,351.049-432.3,351.052Zm-12.8,5.87c-.028.244-.061.4-.061.559q-.005,9.507.007,19.015a2.845,2.845,0,0,0,.276,1.123c2.727,6.024,5.476,12.038,8.193,18.066a1.007,1.007,0,0,0,1.09.7c2.188-.031,4.378-.038,6.567,0a1.082,1.082,0,0,0,1.155-.778c2.719-6.027,5.466-12.042,8.182-18.071a3.552,3.552,0,0,0,.275-1.41q.027-9.066.012-18.133v-1.077Z",
    transform: "translate(450.968 -315.561)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3934",
    "data-name": "Path 3934",
    d: "M-416.223,199.531a14.724,14.724,0,0,1-14.7-14.786,14.8,14.8,0,0,1,14.768-14.652,14.713,14.713,0,0,1,14.661,14.821A14.629,14.629,0,0,1-416.223,199.531Zm.052-23.6a8.842,8.842,0,0,0-8.919,8.94,8.922,8.922,0,0,0,8.888,8.912,9.038,9.038,0,0,0,8.964-8.983A8.92,8.92,0,0,0-416.17,175.933Z",
    transform: "translate(434.854 -170.093)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3935",
    "data-name": "Path 3935",
    d: "M-149.324,184.816a14.721,14.721,0,0,1,14.667-14.722,14.814,14.814,0,0,1,14.779,14.749,14.73,14.73,0,0,1-14.8,14.687A14.66,14.66,0,0,1-149.324,184.816Zm23.612.065a8.848,8.848,0,0,0-8.917-8.948,8.914,8.914,0,0,0-8.934,8.86,9.018,9.018,0,0,0,8.945,8.993A8.95,8.95,0,0,0-125.712,184.882Z",
    transform: "translate(198.083 -170.094)",
    fill: "#d10a11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMatchesIcon);
export default __webpack_public_path__ + "static/media/NewMatchesIcon.750f6ec642817b2722bb618d2b07f5f1.svg";
export { ForwardRef as ReactComponent };